module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibCommission-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.ibCommissionLan.templateSetting))]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('ib-template-setting-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '0',
      "curArea": _vm.curArea,
      "viewBtn": _vm.viewBtn
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('ib-template-setting-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-905e0842","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBTemplateSetting/ibTemplateSetting.vue
// module id = 1130
// module chunks = 1